module.exports = __webpack_public_path__ + "img/float3.8f78649a.svg";